import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right\"><path d=\"M325.008696 908.243478c-6.678261 0-11.130435-2.226087-15.582609-6.678261-8.904348-8.904348-8.904348-22.26087 0-31.165217L667.826087 512 309.426087 151.373913c-8.904348-8.904348-8.904348-22.26087 0-31.165217 8.904348-8.904348 22.26087-8.904348 31.165217 0l373.982609 373.982609c8.904348 8.904348 8.904348 22.26087 0 31.165217L340.591304 901.565217C336.13913 906.017391 329.46087 908.243478 325.008696 908.243478z\" p-id=\"1979\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/right.svg
// module id = 9iyg
// module chunks = 11 12 13